export default "__VITE_ASSET__DaVDWsAO__"